
    export const weton_35 = {};
    export const WETON_35_LIST = [];
    export const KAMUS_WIWIT_TERNAK = [];
    export const KAMUS_JALARAN_LORO = [];
    export const KAMUS_GEBLAK = [];
    export const lookupWetonTernakLoroGeblak = () => null;
  